import { gql } from '@apollo/client';

const createSignatureToListNFTForSaleMutation = gql `
  mutation createSignatureToListNFTForSale(
    $orgId: UUID1!
    $nftTokenId: UUID1!
    $tokenType: TokenType!
    $quantity: Int!
    $nftOwnerAddress: String!
    $fixedPrice: Float!
    $paymentToken: String!
    $currencyId: UUID1!
  ) {
    createSignatureToListNFTForSale(
      orgId: $orgId
      nftTokenId: $nftTokenId
      tokenType: $tokenType
      quantity: $quantity
      nftOwnerAddress: $nftOwnerAddress
      fixedPrice: $fixedPrice
      paymentToken: $paymentToken
      currencyId: $currencyId
    ) {
      messageToSign
      order {
        id
        nftTokenId
        tokenContract
        tokenId
        tokenType
        quantity
        nftOwnerAddress
        fixedPrice
        paymentToken
        orderType
      }
    }
  }
`;
const submitProofOfApprovalMutation = gql `
  mutation submitProofOfApproval(
    $orgID: UUID1!
    $nftTokenId: UUID1!
    $signature: String!
    $quantity: Int
    $fixedPrice: Float
    $paymentToken: String
    $currencyId: UUID1
    $creatorFee: Float
  ) {
    submitProofOfApproval(
      orgID: $orgID
      nftTokenId: $nftTokenId
      signature: $signature
      quantity: $quantity
      fixedPrice: $fixedPrice
      paymentToken: $paymentToken
      currencyId: $currencyId
      creatorFee: $creatorFee
    )
  }
`;
const removeListingMutation = gql `
  mutation removeListing($orgID: UUID1!, $nftTokenId: UUID1!) {
    removeListing(nftTokenId: $nftTokenId, orgID: $orgID)
  }
`;

export { createSignatureToListNFTForSaleMutation, removeListingMutation, submitProofOfApprovalMutation };
